/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Port scanner service
 */
namespace Application.Services {
    'use strict';
    
    import IJob = Models.IJob;
    import IJobRequest = Models.IJobRequest;

    /**
     * PortScannerJob service
     */
    export class PortScannerJobService {
        public static $name: string = "portScannerJobService";
        public static $inject: string[] = ['$http'];

        private http: ng.IHttpService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'jobs/portscanner';

        constructor($http: ng.IHttpService) {
            this.http = $http;
        }
        
        public createPortScannerJob(portScannerJobRequest: IJobRequest): ng.IPromise<IJob> {
            return this.http.post(this.backendUrl, portScannerJobRequest)
                .then((data: ng.IHttpPromiseCallbackArg<IJob>) => {
                    return this.burnishNode(data.data);
                });
        }
        
        public getJobsByProbeSerial(probeSerial: string): ng.IPromise<IJob[]> {
            return this.http.get(this.backendUrl + "/findbyprobeserial/" + probeSerial)
                .then((data: ng.IHttpPromiseCallbackArg<IJob[]>) => {
                    data.data.forEach((job: IJob) => {
                        this.burnishNode(job);
                    });
                    return data.data;
                });
        }

        public getJobsByProbeId(probeId: number): ng.IPromise<IJob[]> {
            return this.http.get(this.backendUrl + "/findbyprobeid/" + probeId)
                .then((data: ng.IHttpPromiseCallbackArg<IJob[]>) => {
                    data.data.forEach((job: IJob) => {
                        this.burnishNode(job);
                    });
                    return data.data;
                });
        }
        
        public getJobById(jobId: string): ng.IPromise<IJob> {
            return this.http.get(this.backendUrl + "/" + jobId)
                .then((data: ng.IHttpPromiseCallbackArg<IJob>) => {
                    return this.burnishNode(data.data);
                });
        }

        public deleteJobById(jobId: string): ng.IHttpPromise<boolean> {
            return this.http.delete(this.backendUrl + "/" + jobId);
        }

        private burnishNode(element: IJob): IJob {
            element.jobType = Models.JobType.PORT_SCANNER;
            return element;
        }
    }
}